module.exports = __webpack_public_path__ + "img/nosotros-ecuador.97686a33.png";